export default __webpack_public_path__ + "static/media/Arrow.7a7711c9.svg";